import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../views/Login.vue'
import NoAccess from '../views/NoAccess.vue'
import NotFound from '../views/NotFound.vue'
import Logout from "@/views/Logout.vue";
import DownloadApp from "@/views/DownloadApp.vue";

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Index'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: NoAccess
  },
  {
    path: '/download-app',
    name: 'DownloadApp',
    component: DownloadApp
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
